import { useEffect } from 'react';
import { dataManager } from '../utils/dataManager';

export function useThemeEffect() {
  useEffect(() => {
    // Subscribe to theme changes
    const applyTheme = () => {
      const theme = dataManager.getTheme();
      const root = document.documentElement;
      if (theme === 'light') {
        root.setAttribute('data-theme', 'light');
      } else {
        root.removeAttribute('data-theme');
      }
    };

    applyTheme(); // Initial apply
    return dataManager.subscribe(applyTheme);
  }, []);
}